import { useWizardStore } from '../store/wizardStore';
import { Step0_VariantSelect } from '../steps/Step0_VariantSelect';
import { Step2_YellowForm } from '../steps/Step2_YellowForm';
import { Step3_GreenForm } from '../steps/Step3_GreenForm';
import { StepReview } from '../steps/StepReview';
import { Step4_Signatures } from '../steps/Step4_Signatures';
import { Step5_Insert } from '../steps/Step5_Insert';
import { Step6_Summary } from '../steps/Step6_Summary';
import { TestModePanel } from '../components/TestModePanel';

export function WizardPage() {
  const step = useWizardStore((s) => s.step);
  switch (step) {
    case 'variant':
      return (
        <>
          <Step0_VariantSelect />
          <TestModePanel />
        </>
      );
    case 'yellow':
      return <Step2_YellowForm />;
    case 'green':
      return <Step3_GreenForm />;
    case 'review':
      return <StepReview />;
    case 'signatures':
      return <Step4_Signatures />;
    case 'insert':
      return <Step5_Insert />;
    case 'summary':
      return <Step6_Summary />;
    default:
      return <Step0_VariantSelect />;
  }
}
